// The star on the home's Horoscope button: tonight's constellations have
// grown since the player last opened the Horoscope, and tonight's is not yet
// written. Remembered per device, for tonight only (docs/01-Product/Horoscope.md).
import type { NightResponse } from '../api/types';

export const HOROSCOPE_SEEN_KEY = 'wits.horoscope.seen';

interface Seen {
  date: string;
  made: number;
}

function read(): Seen | null {
  try {
    const raw = localStorage.getItem(HOROSCOPE_SEEN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Seen>;
    return typeof parsed.date === 'string' ? { date: parsed.date, made: Number(parsed.made) || 0 } : null;
  } catch {
    return null;
  }
}

/** The constellations a night's own levels have made so far (the week's stay out of the Horoscope, proposed 2026-11-02). */
export function constellationsMade(night: NightResponse): number {
  return night.daily.reduce((n, v) => n + (v.constellations ?? 0), 0);
}

/** Whether the Horoscope button carries the star. */
export function horoscopeNoticeDue(night: NightResponse | null): boolean {
  if (!night || night.date !== night.tonight || night.horoscopeWritten) return false;
  const seen = read();
  return constellationsMade(night) > (seen?.date === night.date ? seen.made : 0);
}

/** The player has opened the Horoscope with this many of the night's constellations. */
export function noteHoroscopeSeen(date: string, made: number): void {
  try {
    localStorage.setItem(HOROSCOPE_SEEN_KEY, JSON.stringify({ date, made } satisfies Seen));
  } catch {
    // Private mode or blocked storage: the star stays until tonight's is written.
  }
}
